import { render } from "./Offer.vue?vue&type=template&id=38ad96ca&scoped=true"
import script from "./Offer.vue?vue&type=script&lang=js"
export * from "./Offer.vue?vue&type=script&lang=js"

import "./Offer.vue?vue&type=style&index=0&id=38ad96ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ad96ca"]])

export default __exports__